var map = {
	"./bj_1.png": 90169,
	"./bj_2.png": 76162,
	"./bj_3.png": 39819,
	"./bj_4.png": 47828,
	"./bj_5.png": 68957,
	"./bj_6.png": 1542,
	"./bj_7.png": 70287,
	"./bj_8.png": 68632,
	"./lx_1.png": 19897,
	"./lx_2.png": 36962,
	"./lx_3.png": 27467,
	"./lx_4.png": 77556,
	"./lx_5.png": 98685,
	"./lx_6.png": 1126,
	"./lx_7.png": 82671,
	"./lx_8.png": 7864,
	"./zx_1.png": 75103,
	"./zx_2.png": 45188,
	"./zx_3.png": 87693,
	"./zx_4.png": 6130,
	"./zx_5.png": 55131,
	"./zx_6.png": 96,
	"./zx_7.png": 71273,
	"./zx_8.png": 56030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87358;